import { useState } from "react";
import SubTabParent from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabParent";
import SubTabSection from "../../../../_shoru_shared_library/components/console_page/sub_tab/SubTabSection";
import FormButton from "../../../../_shoru_shared_library/components/form/FormButton";
import FormInput from "../../../../_shoru_shared_library/components/form/FormInput";
import { addRole, addTime } from "../../../../CastingBotFirebase";
import PrettifyDate from "../../../../_shoru_shared_library/functions/PrettifyDate";

function AddTimesTab(props) {

  const userData = props.userData;
  const castingData = props.extraData;
  const setCastingData = props.setExtraData;

  const [date, setDate] = useState('');
  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');
  const [location, setLocation] = useState('');
  const [slotLength, setSlotLength] = useState(15);
  const [log, setLog] = useState([]);

  const logDisplay = log.map((item, index) => {
    return (
      <p  key={index} style={{
        ...{marginTop: '0'},
        ...{marginBottom:'0'},
        ...{color:'#2ecc71'},
        ...{fontSize: '12px'}
      }}>
        {item}
      </p>
    )
  })

  return (
    <SubTabParent passData={props}>
      <SubTabSection description='Times are blocks of audition slots. Audition slots do NOT have to be added individually'>
        <FormInput required title='Date' value={date} setValue={setDate} type='date' />
        <FormInput required title='Start Time' value={start} setValue={setStart} type='time' />
        <FormInput required title='End Time' value={end} setValue={setEnd} type='time' />
        <FormInput required title='Location' value={location} setValue={setLocation} type='text' />
        <FormInput required title='Slot Length (minutes)' value={slotLength} setValue={setSlotLength} type='number' />
        <FormButton label='Add Time' accentColour={props.accentColour} onClick={async() => {
          const time = _validateAndGetTime(date, start, end, location, slotLength);
          if (time !== null) {
            await addTime(time, userData.active_organisation_id, castingData.uid, setCastingData)
            .then(() => {
              setLog([('Created Time: ' + PrettifyDate(date) + ', ' + start + ' -> ' + end + ', ' + location),...log]);
            }, (rejection) => {alert('Could not create new time. Please try again.')});
          };
        }} />
        {log.length > 0? (
          <div style={{marginTop: '30px'}}>
            {logDisplay}
          </div>
        ) : null}
      </SubTabSection>
    </SubTabParent>
  )

}

export default AddTimesTab;


const _validateAndGetTime = (date, start, end, location, slotLength) => {
  if(date === '' || start === '' || end === '' || location === '' || slotLength === null)
  {
    alert('Fill out all required fields');
    return null;
  }
  else if(slotLength < 1)
  {
    alert('Slot length must be greater than zero')
    return null;
  }
  else if(start >= end)
  {
    alert('Start time cannot be after end time')
    return null;
  }
  else {
    return {
      date: date,
      start: start,
      end: end,
      location: location,
      slot_length: slotLength
    }
  }
}